<template>
  <div class="modal fade update-payment-method-modal" id="UpdatePaymentMethodModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="modal-header">
                  <h1 class="modal-title fs-5">Editar método de pagamento</h1>
                  <button type="button" class="btn-close update-payment-method-modal" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <form ref="formUpdatePaymentMethod" @submit.prevent="updatePaymentMethodFunction">
                <div class="modal-body ps-30 pe-30">
                  <p>Preencha as informações abaixo para atualizar o método de pagamento</p>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="name_payment_method_update" class="form-label fw-medium">Nome do método</label>
                    <input
                      type="text"
                      class="form-control"
                      id="name_payment_method_update"
                      v-model="payment_method_name"
                      required
                    />
                  </div>
                  
                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <label for="fee_payment_method_update" class="form-label fw-medium">Taxa (%)</label>
                    <input
                      type="number"
                      class="form-control"
                      id="fee_payment_method_update"
                      v-model.number="payment_method_fee"
                      step="0.01"
                      min="0"
                    />
                  </div>

                  <div class="mb-15 mb-mb-15 mb-md-20 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-30">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="active_payment_method_update"
                        v-model="payment_method_active"
                      />
                      <label class="form-check-label" for="active_payment_method_update">
                        Ativar este método de pagamento
                      </label>
                    </div>
                  </div>

                  <div class="col-12">
                    <div id="alertResponseApiUpdatePaymentMethod" class="toast align-items-center text-bg-success border-0 mt-4 w-100" role="alert" aria-live="assertive" aria-atomic="true">
                      <div class="d-flex">
                        <div class="toast-body fs-md-15 fs-lg-16" id="errorMessageUpdatePaymentMethod"></div>
                      </div>
                    </div>
                  </div>
                  
                </div>
                
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger update-payment-method-modal" data-bs-dismiss="modal">Cancelar</button>
                  <button type="submit" ref="buttonUpdatePaymentMethod" class="btn btn-success">Salvar método</button>
                </div>
              </form>
          </div>
      </div>
  </div>
</template>

<script>
import api from '../../config/axios.js';
import { mapGetters } from 'vuex';

export default {
  name: "UpdatePaymentMethodModal",
  data() {
    return {
      payment_method_name: "",
      payment_method_fee: null,
      payment_method_active: true
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentUpdatePaymentMethod"
    ]),
  },
  watch: {
    getCurrentUpdatePaymentMethod: {
      immediate: true,
      handler(paymentMethod) {
        if (paymentMethod) {
            console.log(paymentMethod);
          this.payment_method_name = paymentMethod.name;
          this.payment_method_fee = paymentMethod.tax || 0;
          this.payment_method_active = paymentMethod.active == 1 ? true : false;
        }
      }
    }
  },
  methods: {
    updatePaymentMethodFunction() {
      const alertResponse = this.alertResponse;

      if (this.payment_method_name === "") {
        this.alertResponse("Por favor preencha o nome do método de pagamento", true);
        return;
      }

      const objPaymentMethodUpdate = {
        "id": this.getCurrentUpdatePaymentMethod.id,
        "name": this.payment_method_name,
        "fee": this.payment_method_fee || 0,
        "active": this.payment_method_active
      }

      const buttonUpdatePaymentMethod = this.$refs.buttonUpdatePaymentMethod;
      buttonUpdatePaymentMethod.disabled = true;
      buttonUpdatePaymentMethod.innerHTML = "Salvando método...";
      
      api.axios.post("/api/payment-methods/update", objPaymentMethodUpdate).catch(function(error) {
        buttonUpdatePaymentMethod.disabled = false;
        buttonUpdatePaymentMethod.innerHTML = "Salvar método";
        console.log("error", error);
        if (error.response && error.response.data) {
          alertResponse(error.response.data.message || "Erro ao atualizar método de pagamento", true);
        } else {
          alertResponse("Erro ao atualizar método de pagamento", true);
        }
      }).then(function(response) {
        if (response !== undefined && response.status == 200) {
          buttonUpdatePaymentMethod.innerHTML = "Método atualizado com sucesso!";
          window.location.reload();
        } else {
          buttonUpdatePaymentMethod.disabled = false;
          buttonUpdatePaymentMethod.innerHTML = "Salvar método";
        }
      });
    },
    alertResponse(message, error) {
      const warningMessage = `<i class="flaticon flaticon-warning"></i> ` + message;
      const successMessage = `<i class="flaticon flaticon-check"></i> ` + message;
      
      if (error) {
        document.getElementById("errorMessageUpdatePaymentMethod").innerHTML = warningMessage;
      } else {
        document.getElementById("errorMessageUpdatePaymentMethod").innerHTML = successMessage;
      }

      const elementAlert = document.getElementById("alertResponseApiUpdatePaymentMethod");
      if (elementAlert) {
        if (error) {
          elementAlert.classList.add('bkred');
        } else {
          elementAlert.classList.remove('bkred');
        }
        elementAlert.style.display = "block";
        setTimeout(() => {
          elementAlert.style.display = "none";
        }, 7000);
      }
    },
  }
};
</script>
